import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login       from './pages/Login';
import Dashboard   from './pages/Dashboard';
import Clients     from './pages/Clients';
import Supervision from './pages/Supervision';
import Walkthrough from './pages/Walkthrough';
import Calibration from './pages/Calibration';
import Campagne    from './pages/Campagne';
import Enrollment  from './pages/Enrollment';
import Zones        from './pages/Zones';
import Provisioning from './pages/Provisioning';
import Logs         from './pages/Logs';
import Flash        from './pages/Flash';
import Sites        from './pages/Sites';
import Layout      from './components/Layout';

const theme = createTheme({
  palette: {
    primary:    { main: '#1F4E79' },
    secondary:  { main: '#2E75B6' },
    background: { default: '#F5F7FA' },
  },
  typography: { fontFamily: 'Inter, Arial, sans-serif' },
});

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index              element={<Clients />} />
        <Route path="dashboard"   element={<Dashboard />} />
        <Route path="clients"     element={<Clients />} />
        <Route path="supervision" element={<Supervision />} />
        <Route path="walkthrough" element={<Walkthrough />} />
        <Route path="calibration" element={<Calibration />} />
        <Route path="campagne"    element={<Campagne />} />
        <Route path="enrollment"  element={<Enrollment />} />
        <Route path="zones"       element={<Zones />} />
        <Route path="provisioning" element={<Provisioning />} />
        <Route path="logs" element={<Logs />} />
        <Route path="flash" element={<Flash />} />
        <Route path="sites" element={<Sites />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
